import { Slider, SliderItem } from "../../../common/slider/Slider";
import RecentBlogStyleWrapper from "./RecentBlog.style";
import SectionTitle from "../../../common/sectionTitle";
import data from "../../../assets/data/blog/blogItems";
import BlogItem from "../blog/blogItem/BlogItem";
import Button from "../../../common/button";
import { useNavigate } from "react-router-dom";

const RecentBlog = () => {

    const navigate = useNavigate();

    const navigateTo = (path) => {
        window.scrollTo(0, 0);
        navigate(path);
    }

    const slider = {
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: "linear",
        centerPadding: "0px",
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    const { posts } = data;

    return (
        <RecentBlogStyleWrapper>
            <div className="blog_sect" id="blog">
                <div className="v1_blog_overlay">
                    <div className="container">
                        <SectionTitle title="Recent Blog" subtitle="BLOG & ARTICAL" />
                        <div className="blog_item_section">
                            <Slider {...slider}>
                                {posts?.map((item, i) => (
                                    <SliderItem key={i}>
                                        <BlogItem {...item} />
                                    </SliderItem>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
                <Button lg variant="outline" className="view_btn" onClick={() => navigateTo("/blogs")} >View More Blog</Button>
            </div>
        </RecentBlogStyleWrapper>
    )
}

export default RecentBlog;